/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ScrollView,
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Dimensions,
  FlatList,
  ImageBackground,
  Pressable,
  Platform,
} from 'react-native';
import PropTypes from 'prop-types';
import { useHeaderHeight } from '@react-navigation/elements';
import {
  isNative,
  isWeb,
  isMobileWeb,
  maxWidthContainer,
} from '~global/screens';
import { data as Font } from '~global/Fonts';
import Colors from '~global/Colors';
import FooterWeb from '@web-components/common/footer/FooterWeb';
import FooterMobileWeb from '@web-components/common/footer/FooterMobileWeb';
import Image from '@web-components/common/Image';

import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';
import { headerTitleStyle } from '~assets/styles/headerStyles';
const HomeHeader = React.lazy(() =>
  import('@web-components/headers/HomeHeader'),
);
const { width, height } = Dimensions.get('window');
const screenHeight = height;
const screenWidth = width;

let lastPosition = 0;
let minusMargin = 0;
if (screenWidth > maxWidthContainer) {
  minusMargin = Math.round((screenWidth - maxWidthContainer) / 2);
}

const LayoutWrapper = React.memo(
  (childProps) => {
    const { scrollContainerRef, image, footerComponent, isHomePage } =
      childProps;
    const dispatch = useDispatch();
    const handler = (e) => {
      lastPosition = e?.nativeEvent?.contentOffset?.y;
      dispatch({ type: 'home/setContentOffsetY', data: lastPosition });
    };

    if (isWeb && image) {
      return (
        <ImageBackground
          source={image}
          resizeMode="cover"
          style={childProps.style ? childProps.style : {}}>
          <ScrollView
            ref={scrollContainerRef}
            showsVerticalScrollIndicator={false}
            scrollEventThrottle={0}
            style={{ zIndex: 1, elevation: 1 }}
            {...(isHomePage ? { onScroll: handler } : {})}>
            {childProps.children}
          </ScrollView>
          {footerComponent ? footerComponent : false}
        </ImageBackground>
      );
    }
    return (
      <ScrollView
        ref={scrollContainerRef}
        scrollEventThrottle={0}
        onScroll={handler}
        {...childProps}
      />
    );
  },
  (prev, next) => prev == next,
);

// eslint-disable-next-line react/display-name
// Global container with content inside
const Container = React.memo(
  (props) => {
    const {
      containerStyle = {},
      image = '',
      footerComponent = false,
      content = true,
      showHomeHeader = false,
    } = props;
    const scrollContainerRef = useRef(null);
    const navigation = useNavigation();

    useEffect(() => {
      let mounted = true;
      if (mounted && isWeb) {
        let same_route = true;
        if (navigation?.getState()?.routes?.length) {
          const routes = navigation.getState().routes;
          if (
            routes?.length > 1 &&
            global.previousRouteName &&
            global.currentRouteName
          ) {
            same_route = global.previousRouteName == global.currentRouteName;
          }
        }
        if (lastPosition > 0 && scrollContainerRef?.current) {
          if (!same_route) {
            global.previousRouteName = global.currentRouteName;
            lastPosition = 0;
          }
          scrollContainerRef.current?.scrollTo({
            y: lastPosition,
            animated: false,
          });
        }
      }
      return () => {
        mounted = false;
      };
    }, [props]);

    const ContentWrapper = useMemo(() => {
      return content ? <Content {...props} /> : props.children;
    }, [props, content]);

    const ContainerWrapper = useMemo(() => {
      return !isNative ? (
        <LayoutWrapper
          {...props}
          style={[styles.container, containerStyle]}
          image={image}
          footerComponent={footerComponent}>
          {isWeb && showHomeHeader && <HomeHeader {...props} />}
          {ContentWrapper}
        </LayoutWrapper>
      ) : (
        props.children
      );
    }, [props, containerStyle, ContentWrapper]);

    return ContainerWrapper;
  },
  (prev, next) => prev == next,
);

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

// global wrapper width
const Wrapper = React.memo(
  (props) => {
    const { containerStyle = {} } = props;
    return <View style={[styles.wrapper, containerStyle]} {...props}></View>;
  },
  (prev, next) => prev == next,
);

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

// global content width
const Content = React.memo(
  (props) => {
    const { isFullWidth = false, isNoFooter = false, style = {} } = props;
    const navigation = useNavigation();
    const { dropdowns } = useSelector((state) => state.home);
    const showOverlay = dropdowns.some(({ show }) => show);
    // const insets = useSafeAreaInsets();
    return (
      <View>
        {/* {!isErrorPage && ( */}
        <View
          {...props}
          style={[
            styles.containerStyle,
            isFullWidth ? { maxWidth: screenWidth } : {},
            style,
          ]}
        />
        {/* )} */}

        {/* <ErrorPage
          {...props}
          navigation={navigation}
          responseCode={isErrorPage}
        /> */}
        {isWeb && !isNoFooter && <FooterWeb navigation={navigation} />}
        {isMobileWeb && !isNoFooter && (
          <FooterMobileWeb navigation={navigation} />
        )}
        {showOverlay && <View style={styles.overlay} />}
      </View>
    );
  },
  (prev, next) => prev == next,
);

Content.propTypes = {
  children: PropTypes.node.isRequired,
};

// flatlist with websupport
const FlatListWeb = React.memo(
  (props) => {
    const { style = {} } = props;

    return <FlatList {...props} style={style} />;
  },
  (prev, next) => prev == next,
);

const FlexWrapper = React.memo(
  (props) => {
    const { style = {}, isBetween = false } = props;
    return (
      <View
        {...props}
        style={[styles.flexWrapper, isBetween ? styles.rowBetween : {}, style]}
      />
    );
  },
  (prev, next) => prev == next,
);

FlexWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isBetween: PropTypes.bool,
};

const Row = React.memo(
  (props) => {
    const { style = {}, isBetween = false, isCenter = false } = props;
    return (
      <View
        {...props}
        style={[
          styles.rowWrapper,
          isBetween ? styles.rowBetween : {},
          isCenter ? styles.rowCenter : {},
          style,
        ]}
      />
    );
  },
  (prev, next) => prev == next,
);

Row.propTypes = {
  children: PropTypes.node.isRequired,
  isBetween: PropTypes.bool,
  isCenter: PropTypes.bool,
};

const RowProduct = React.memo(
  ({ children }) => {
    return (
      <Row isBetween style={styles.rowProduct}>
        {children}
      </Row>
    );
  },
  (prev, next) => prev == next,
);

const FilterLeft = React.memo(
  ({ children }) => {
    return <View style={styles.filterLeft}>{children}</View>;
  },
  (prev, next) => prev == next,
);

const ProductContainer = React.memo(
  (props) => {
    return <View style={styles.productContainer} {...props} />;
  },
  (prev, next) => prev == next,
);

const Pagination = React.memo(
  ({
    totalProduct = 0,
    limit = 16,
    style = {},
    onChange,
    criteria = null,
    currentPageParams,
  }) => {
    const paramsState = useSelector((state) => state.productFilters.params);
    const iconLeft = require('~assets/img/arrow-left-white.svg');
    const iconRight = require('~assets/img/arrow-right-white.svg');
    const arrowLeft = isWeb ? { uri: iconLeft } : iconLeft;
    const arrowRight = isWeb ? { uri: iconRight } : iconRight;
    const separator = '...';
    const params = useMemo(() => {
      if (criteria) {
        return criteria;
      }
      if (paramsState) {
        return paramsState;
      }
    }, [paramsState, criteria]);

    let currentPage = currentPageParams ? Number(currentPageParams) : 1;
    let pages = [];
    const calculate = Math.ceil(Number(totalProduct) / limit);
    const totalPage = calculate > 0 ? calculate : 1;

    for (let i = 0; i < totalPage; i++) {
      pages.push(i + 1);
    }

    if (
      params?.skip &&
      !isNaN(Number(params.skip)) &&
      Number(params.skip) > 0
    ) {
      const skip = Number(params.skip);
      currentPage = Math.floor(skip / limit + 1);
    }

    if (pages.length > 10) {
      let first = pages.slice(0, 5);
      let last = pages.slice(pages.length - 5);
      if (currentPage > 5 && currentPage < pages.length - 5) {
        const middle = pages.slice(currentPage - 1, currentPage + 1);
        first = first.filter((a) => !middle.includes(a));
        last = last.filter((a) => !middle.includes(a));
        pages = [...first, separator, ...middle, separator, ...last];
      } else {
        pages = [...first, separator, ...last];
      }
    }

    const onChangePagination = (page) => {
      if (page != separator) {
        const skip = (page - 1) * limit;
        onChange(skip, page);
      }
    };

    const isDisabled = (isNext = false) => {
      if (isNext) {
        return currentPage >= totalPage;
      } else {
        return currentPage <= 1;
      }
    };

    const onNext = () => {
      if (!isDisabled(true)) {
        const skip = (currentPage - 1 + 1) * limit;
        onChange(skip, currentPage + 1);
      }
    };

    const onPrev = () => {
      if (!isDisabled()) {
        const skip = (currentPage - 1 - 1) * limit;
        onChange(skip, currentPage - 1);
      }
    };

    return (
      <View
        style={[
          styles.rowWrapper,
          styles.rowCenter,
          styles.rowContentCenter,
          styles.paginationWrapper,
          style,
        ]}>
        {/* Arrow Left Start */}
        <TouchableOpacity
          style={[
            styles.paginationArrow,
            styles.paginationArrowLeft,
            isDisabled() ? styles.paginationArrowDisabled : {},
          ]}
          activeOpacity={0.6}
          onPress={() => onPrev()}>
          <Image source={arrowLeft} style={styles.paginationArrowIcon} />
        </TouchableOpacity>
        {/* Arrow Left End */}

        {/* Numbers */}
        {pages.map((item, idx) => (
          <TouchableOpacity
            style={styles.paginationItem}
            key={`pagination-${idx}`}
            activeOpacity={item != separator ? 0.6 : 1}
            onPress={() => onChangePagination(item)}>
            <Text
              style={[
                styles.paginationItemText,
                currentPage == item ? styles.paginationItemTextActive : {},
              ]}>
              {item}
            </Text>
          </TouchableOpacity>
        ))}
        {/* Numbers */}

        {/* Arrow Right Start */}
        <TouchableOpacity
          style={[
            styles.paginationArrow,
            styles.paginationArrowRight,
            isDisabled(true) ? styles.paginationArrowDisabled : {},
          ]}
          activeOpacity={0.6}
          onPress={() => onNext()}>
          <Image source={arrowRight} style={styles.paginationArrowIcon} />
        </TouchableOpacity>
        {/* Arrow Right End */}
      </View>
    );
  },
  (prev, next) => prev == next,
);

Pagination.propTypes = {
  style: PropTypes.object,
  totalProduct: PropTypes.number,
  limit: PropTypes.number,
  onChange: PropTypes.func,
};

const LilacContainer = ({ children, style }) => {
  const win = Dimensions.get('window');
  const ratio = win.width / 1442;
  const heightHeader = useHeaderHeight();
  const height = screenHeight - (isWeb ? 155 : heightHeader);
  return (
    <ScrollView style={{ height }}>
      <View
        style={[
          styles.containerWeb,
          { minHeight: isWeb ? 'calc(100vh - 78px)' : 'auto' },
          style,
        ]}>
        {children}
        <ImageBackground
          style={[
            { width: win.width, height: 215 * ratio },
            styles.bottomBackground,
          ]}
          resizeMode="contain"
          source={require('~assets/img/otp-background.png')}
        />
      </View>
    </ScrollView>
  );
};

const HeaderMobile = ({ title, leftAction, withBorder }) => {
  const insets = useSafeAreaInsets();
  const height = 55 + insets.top;
  return (
    <View
      style={[
        styles.headerContainer,
        { height, minHeight: height },
        withBorder && styles.headerBorder,
      ]}>
      <Pressable
        style={styles.headerContainerTitle}
        onPress={() => (leftAction ? leftAction() : false)}>
        <Image
          style={{ height: 20, width: 20 }}
          source={require('~assets/img/common/arrow-back.png')}
        />
      </Pressable>
      <View style={styles.headerTitle}>
        <Text style={headerTitleStyle} numberOfLines={1}>
          {title}
        </Text>
      </View>
    </View>
  );
};

HeaderMobile.propTypes = {
  title: PropTypes.string,
  leftAction: PropTypes.func,
};

const SplitScreens = ({ styleLeft, styleRight }) => {
  return (
    <Row style={styles.splitScreens}>
      <View style={styleLeft}></View>
      <View style={styleRight}></View>
    </Row>
  );
};

const styles = StyleSheet.create({
  bottomBackground: {
    position: 'absolute',
    bottom: 0,
    marginHorizontal: -5,
    zIndex: -1,
  },
  container: {
    backgroundColor: Colors.white,
    ...(isWeb ? { overflow: 'auto' } : {}),
  },
  wrapper: {
    width: screenWidth,
    backgroundColor: Colors.white,
  },
  containerStyle: {
    width: '100%',
    maxWidth: maxWidthContainer,
    marginHorizontal: 'auto',
  },
  containerWeb: {
    backgroundColor: Colors.purple25,
    //...(isWeb ? { overflow: 'auto' } : {}),
    alignItems: 'center',
  },
  flexWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: -9,
  },
  headerContainer: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  headerBorder: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey6,
  },
  headerContainerTitle: {
    paddingLeft: 16,
  },
  headerTitle: {
    paddingLeft: 20,
    paddingRight: 16,
    flex: 1,
    textAlign: 'left',
  },
  rowWrapper: {
    flexDirection: 'row',
  },
  rowBetween: {
    justifyContent: 'space-between',
  },
  rowCenter: {
    alignItems: 'center',
  },
  rowContentCenter: {
    justifyContent: 'center',
  },
  filterLeft: {
    width: 290,
    marginRight: 30,
  },
  productContainer: { width: isWeb ? 930 : screenWidth },
  paginationWrapper: {
    paddingVertical: 15,
    marginTop: 15,
    borderTopColor: Colors.grey0,
    borderTopWidth: 1,
  },
  paginationItem: {
    marginHorizontal: 6,
  },
  paginationItemText: {
    fontSize: 14,
    ...Font.figtreeMedium,
  },
  paginationItemTextActive: {
    fontSize: 14,
    color: Colors.purple4,
    ...Font.figtreeMedium,
  },
  paginationArrow: {
    width: 20,
    height: 20,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    backgroundColor: Colors.purple4,
  },
  paginationArrowDisabled: {
    backgroundColor: Colors.grey0,
  },
  paginationArrowLeft: {
    marginRight: 10,
  },
  paginationArrowRight: {
    marginLeft: 10,
  },
  paginationArrowIcon: {
    width: 5,
    height: 8,
  },
  rowProduct: {
    marginTop: 15,
    marginBottom: 40,
  },

  splitScreens: {
    ...Platform.select({
      android: {},
      web: {
        width: '100vw',
        height: '100%',
        marginLeft: minusMargin > 0 ? minusMargin * -1 : minusMargin,
        position: 'absolute',
        zIndex: -1,
      },
    }),
  },
  overlay: {
    ...(isWeb && { backgroundColor: 'rgba(0,0,0, .2)' }),
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
});

export { Container, Row, FlatListWeb, LilacContainer, HeaderMobile };

export default {
  Container,
  Wrapper,
  Content,
  FlatListWeb,
  FlexWrapper,
  Row,
  RowProduct,
  FilterLeft,
  ProductContainer,
  Pagination,
  LilacContainer,
  HeaderMobile,
  // SidebarProfile,
  SplitScreens,
};
